import React, { useState } from "react";
import { Select, MenuItem } from "@mui/material";
import { useGetDropdownUsersQuery } from "../../api/getEmployeeList";
import { useGetEmployeeListQuery } from "../../api/addEmployeeApi";
import "../../css/dropdown.css";
import { useGetAllEmployeeLeavesQuery } from "../../api/employeeLeaves";
import { v4 as uuidv4 } from "uuid";
import { useGetAllLeaveCategoriesQuery } from "../../api/leaveploicyApi";
import { genericHeaders, serviceUrl } from "../../../src/utils/apiConfig";
import axios from "axios";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
} from "@mui/material";
import { cloneDeep } from "lodash";
import dayjs from "dayjs";
import { getToken } from "../../services/Token";
import ViewAllEmployeeLeaves from "./ViewAllEmployeeLeaves";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";

export default function Leavepolicy() {
  const [isEditing, setIsEditing] = useState(false);
  const [editedValue, setEditedValue] = useState("");
  const [editedRowId, setEditedRowId] = useState(null);
  const [openDialog, setOpenDialog] = useState(null);
  const [leavesError, setLeavesError] = useState(false);
  const handleClickOpenDialog = (rowIndex) => {
    setOpenDialog(rowIndex);
  };

  const handleCloseDialog = () => {
    setOpenDialog(null);
    setIsEditing(false);
  };

  const [employeePayload, setEmployeePayload] = useState([
    {
      isActive: true,
      leaveType: "",
      currentAvailableLeaves: 0,
      leavesObtained: 0,
      leavesAvailed: 0,
      leavesApproved: 0,
      leavesRejected: 0,
    },
  ]);

  const { data: employeeData, isSuccess: employeesIsSuccess } =
    useGetDropdownUsersQuery();
  const { data: allEmployeesData } = useGetEmployeeListQuery();
  let {
    data: leavesData,
    isSuccess: leavesIsSuccess,
    refetch,
  } = useGetAllEmployeeLeavesQuery();
  const { data: leaveTypeData, isSuccess: leaveTypeIsSuccess } =
    useGetAllLeaveCategoriesQuery();

  leavesData = leavesData
    ? leavesData?.data.map((leave) => ({
        id: uuidv4(),
        ...leave,
      }))
    : [];

  const [employeeType, setEmployeeType] = useState("currentEmployee");
  const [selectedEmployee, setSelectedEmployee] = useState(null);

  const handleChange = (event) => {
    setEmployeeType(event.target.value);
  };

  let filteredLeavesData = selectedEmployee
    ? leavesData.find((leave) => leave.employeeId === selectedEmployee.employeeId)
    : [];
  const leaveId = filteredLeavesData ? filteredLeavesData._id : "";
  const selectedEmployeeData = filteredLeavesData ? filteredLeavesData : null;

  const rows =
    selectedEmployeeData && selectedEmployeeData.leaves
      ? selectedEmployeeData.leaves.map((leave, index) => ({
          id: index,
          leaveType: leave.leaveType,
          currentAvailableLeaves: leave.currentAvailableLeaves,
          leavesObtained: leave.leavesObtained,
          leavesAvailed: leave.leavesAvailed,
          leavesApproved: leave.leavesApproved,
          leavesRejected: leave.leavesRejected,
        }))
      : [];
  const columns = [
    {
      field: "leaveType",
      headerName: "Leave Type",
      width: 150,
    },
    {
      field: "currentAvailableLeaves",
      headerName: "Current Available Leaves",
      width: 200,
    },
    {
      field: "leavesObtained",
      headerName: "Leaves Obtained",
      width: 150,
    },
    {
      field: "leavesAvailed",
      headerName: "Leaves Availed",
      width: 150,
    },
    {
      field: "leavesApproved",
      headerName: "Leaves Approved",
      width: 150,
    },
    {
      field: "leavesRejected",
      headerName: "Leaves Rejected",
      width: 150,
    },
  ];

  const transactionColumns = [
    {
      field: "updatedBy",
      headerName: "Updated By",
    },
    {
      field: "leaveType",
      headerName: "Leave Type",
    },
    {
      field: "changedOn",
      headerName: "Changed On",
    },
    {
      field: "from",
      headerName: "From",
    },
    {
      field: "to",
      headerName: "To",
    },
  ];

  const handleChangeEmployee = (event) => {
    const selectedId = event.target.value;
    const employee = employeeData.find((emp) => emp.employeeId === selectedId);
    setSelectedEmployee(employee);
  };
  const handleEditClick = (rowIndex, rowData) => {
    setIsEditing(true);
    setEditedRowId(rowIndex);
    setEditedValue(rowData.currentAvailableLeaves.toString());
  };

  const handleSaveEdit = (rowIndex) => {
    const newValue = parseFloat(editedValue);
    if (!isNaN(newValue)) {
      // Set the edited data and open the dialog
      setEditedRowId(rowIndex);
      setEditedValue(newValue);
      handleClickOpenDialog(rowIndex);
    } else {
      // Handle validation error, if needed
    }
  };
  const saveEditedData = async (updatedData) => {
    const updatedEmployeePayload = updatedData.map((row) => ({
      isActive: "true",
      leaveType: row.leaveType,
      currentAvailableLeaves: row.currentAvailableLeaves,
      leavesObtained: row.leavesObtained,
      leavesAvailed: row.leavesAvailed,
      leavesApproved: row.leavesApproved,
      leavesRejected: row.leavesRejected,
    }));

    try {
      let response = await axios.put(
        `${serviceUrl}/api/employeeLeave/updateEmployeeLeave?employeeLeaveId=${leaveId}`,
        updatedEmployeePayload,
        { headers: genericHeaders() },
      );
      setEmployeePayload(updatedEmployeePayload);
      refetch();
      setOpenDialog(false);
    } catch (err) {
      console.error(err);
    }
  };

  const handleConfirmSave = async () => {
    handleCloseDialog();

    const updatedRows = [...rows];
    updatedRows[editedRowId].currentAvailableLeaves = editedValue;
    const sendOnlyUpdatedLeave = [updatedRows[editedRowId]];
    rows[editedRowId].currentAvailableLeaves = editedValue;
    saveEditedData(sendOnlyUpdatedLeave);
    setIsEditing(false);
    setLeavesError(false);
  };

  const setLeavesEditedValue = (e) => {
    if (e.target.value < 31) {
      setEditedValue(Math.trunc(e.target.value));
      setLeavesError(false);
    } else {
      setEditedValue(30);
      setLeavesError(true);
    }
  };
  //to disaplay the data under leave transcations
  let leaveTranscations = cloneDeep(filteredLeavesData?.leaveEventRelationShip);
  leaveTranscations = leaveTranscations?.map((item) => {
    let updatedEmployee = allEmployeesData?.find(
      (emp) => emp.id === item.eventActor,
    );
    let updatedLeaveType = leaveTypeData?.find(
      (leave) => leave._id === item.leaveType,
    );
    item["eventActor"] = updatedEmployee?.name;
    item["leaveType"] = updatedLeaveType?.leaveCategory;
    return item;
  });
  const handleExport = (type) => {
    let formattedData = [];
    let merges = [];
    let rowIndex = 1;

    if (type === "all") {
      leavesData.forEach((emp) => {
        const startRow = rowIndex;

        emp.leaves?.forEach((leave, index) => {
          formattedData.push({
            Name: index === 0 ? emp.employeeName || emp.employeeId : "",

            "Leave Type":
              leaveTypeData.find((l) => l._id === leave.leaveType)
                ?.leaveCategory || "",

            "Current Available": leave.currentAvailableLeaves,

            "Leaves Obtained": leave.leavesObtained,

            "Leaves Availed": leave.leavesAvailed,

            "Leaves Approved": leave.leavesApproved,

            "Leaves Rejected": leave.leavesRejected,
          });

          rowIndex++;
        });

        const endRow = rowIndex - 1;

        if (startRow < endRow) {
          merges.push({
            s: { r: startRow, c: 0 },
            e: { r: endRow, c: 0 },
          });
        }
      });
    }
    if (type === "single") {
      const startRow = rowIndex;

      selectedEmployeeData?.leaves?.forEach((leave, index) => {
        formattedData.push({
          Name: index === 0 ? selectedEmployee?.name || "" : "",

          "Leave Type":
            leaveTypeData.find((l) => l._id === leave.leaveType)
              ?.leaveCategory || "",

          "Current Available": leave.currentAvailableLeaves,

          "Leaves Obtained": leave.leavesObtained,

          "Leaves Availed": leave.leavesAvailed,

          "Leaves Approved": leave.leavesApproved,

          "Leaves Rejected": leave.leavesRejected,
        });

        rowIndex++;
      });

      const endRow = rowIndex - 1;

      if (startRow < endRow) {
        merges.push({
          s: { r: startRow, c: 0 },
          e: { r: endRow, c: 0 },
        });
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(formattedData, {
      header: [
        "Name",
        "Leave Type",
        "Current Available",
        "Leaves Obtained",
        "Leaves Availed",
        "Leaves Approved",
        "Leaves Rejected",
      ],
    });
    worksheet["!cols"] = [
      { wch: 25 }, // Name
      { wch: 20 }, // Leave Type
      { wch: 15 }, // Current Available
      { wch: 15 }, // Leaves Obtained
      { wch: 15 }, // Leaves Availed
      { wch: 15 }, // Leaves Approved
      { wch: 15 }, // Leaves Rejected
    ];

    worksheet["!merges"] = merges;
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Leave Data");

    if (type === "single") {
      const transactionData =
        leaveTranscations?.map((txn) => ({
          "Updated By": txn.eventActor || "",
          "Leave Type": txn.leaveType || "",
          "Changed On": dayjs(txn.timeStamp).format("DD MMM YYYY") || "",
          From: txn.previousLeaves ?? 0,
          To: txn.updatedleaves ?? 0,
        })) || [];

      const transactionSheet = XLSX.utils.json_to_sheet(transactionData);

      transactionSheet["!cols"] = [
        { wch: 25 },
        { wch: 20 },
        { wch: 20 },
        { wch: 10 },
        { wch: 10 },
      ];

      XLSX.utils.book_append_sheet(
        workbook,
        transactionSheet,
        "Leave Transactions",
      );
    }

    XLSX.writeFile(
      workbook,
      type === "single"
        ? `${selectedEmployee?.name}_Leave.xlsx`
        : "All_Employees_Leave.xlsx",
    );
    const range = XLSX.utils.decode_range(worksheet["!ref"]);

    for (let C = range.s.c; C <= range.e.c; ++C) {
      const cell = worksheet[XLSX.utils.encode_cell({ r: 0, c: C })];
      if (cell) {
        cell.s = {
          alignment: { horizontal: "center" },
          font: { bold: true },
        };
      }
    }
    for (let R = 1; R <= range.e.r; ++R) {
      for (let C = 2; C <= range.e.c; ++C) {
        const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "center" },
          };
        }
      }
    }
    for (let R = 1; R <= range.e.r; ++R) {
      [0, 1].forEach((C) => {
        const cell = worksheet[XLSX.utils.encode_cell({ r: R, c: C })];
        if (cell) {
          cell.s = {
            alignment: { horizontal: "left" },
          };
        }
      });
    }
  };

  const handleDownload = (type) => {
    const doc = new jsPDF();

    doc.setFontSize(18);
    doc.setTextColor(40);
    doc.text("Employee Leave Report", 14, 15);

    doc.setFontSize(11);
    doc.setTextColor(100);
    doc.text(`Employee: ${selectedEmployee?.name || "All Employees"}`, 14, 22);

    doc.text(`Date: ${new Date().toLocaleDateString()}`, 150, 22);

    const tableRows = [];

    if (type === "single") {
      rows.forEach((row, index) => {
        if (index === 0) {
          tableRows.push([
            {
              content: selectedEmployee?.name || "",
              rowSpan: rows.length,
              styles: {
                valign: "middle",
                halign: "left",
              },
            },

            leaveTypeData.find((l) => l._id === row.leaveType)?.leaveCategory ||
              "",

            row.currentAvailableLeaves,
            row.leavesObtained,
            row.leavesAvailed,
            row.leavesApproved,
            row.leavesRejected,
          ]);
        } else {
          tableRows.push([
            leaveTypeData.find((l) => l._id === row.leaveType)?.leaveCategory ||
              "",

            row.currentAvailableLeaves,
            row.leavesObtained,
            row.leavesAvailed,
            row.leavesApproved,
            row.leavesRejected,
          ]);
        }
      });
    } else {
      leavesData.forEach((emp) => {
        emp.leaves?.forEach((leave, index) => {
          // First row of employee
          if (index === 0) {
            tableRows.push([
              {
                content: emp.employeeName || emp.employeeId,
                rowSpan: emp.leaves.length,
                styles: {
                  valign: "middle",
                  halign: "left",
                },
              },

              leaveTypeData.find((l) => l._id === leave.leaveType)
                ?.leaveCategory || "",

              leave.currentAvailableLeaves,

              leave.leavesObtained,

              leave.leavesAvailed,

              leave.leavesApproved,

              leave.leavesRejected,
            ]);
          }

          // Remaining rows
          else {
            tableRows.push([
              leaveTypeData.find((l) => l._id === leave.leaveType)
                ?.leaveCategory || "",

              leave.currentAvailableLeaves,

              leave.leavesObtained,

              leave.leavesAvailed,

              leave.leavesApproved,

              leave.leavesRejected,
            ]);
          }
        });
      });
    }
    autoTable(doc, {
      startY: 25,

      head: [
        [
          "Employee",
          "Leave Type",
          "Available",
          "Obtained",
          "Availed",
          "Approved",
          "Rejected",
        ],
      ],

      body: tableRows,

      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 4,
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
        halign: "center",
        valign: "middle",
        overflow: "linebreak",
      },

      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
        halign: "center",
      },

      bodyStyles: {
        textColor: [0, 0, 0],
      },

      alternateRowStyles: {
        fillColor: [245, 249, 252],
      },

      columnStyles: {
        0: { halign: "left", cellWidth: 52 }, // Employee
        1: { halign: "left", cellWidth: 32 }, // Leave Type
        2: { cellWidth: 22 }, // Available
        3: { cellWidth: 22 }, // Obtained
        4: { cellWidth: 22 }, // Availed
        5: { cellWidth: 22 }, // Approved
        6: { cellWidth: 22 }, // Rejected
      },
    });

    autoTable(doc, {
      startY: doc.lastAutoTable.finalY + 10,

      head: [["Updated By", "Leave Type", "Changed On", "From", "To"]],

      body:
        leaveTranscations?.map((txn) => [
          txn.eventActor || "",
          txn.leaveType || "",
          dayjs(txn.timeStamp).format("DD MMM YYYY") || "",
          txn.previousLeaves ?? 0,
          txn.updatedleaves ?? 0,
        ]) || [],

      theme: "grid",

      headStyles: {
        fillColor: [41, 128, 185],
        textColor: 255,
        fontStyle: "bold",
      },

      styles: {
        fontSize: 10,
        cellPadding: 3,
      },
    });

    const getPdfFileName = () => {
      if (type === "single" && selectedEmployee) {
        const name = selectedEmployee.name || "Employee";
        const id = selectedEmployee.employeeId || "";

        return `${name} (${id})_Leave.pdf`;
      }

      return "All_Employees_Leave.pdf";
    };

    doc.save(getPdfFileName());
  };

  const change = (id) => {
    const selected = employeeData?.find((each) => each.id === id);
    setSelectedEmployee(selected);
  };
  return (
    <>
      <div className="flex flex-col border border-gray-300 rounded-2xl bg-white w-[90%] ml-4 mt-[8rem]">
        <div className="flex flex-row justify-between pt-4 mb-4">
          <h1 className="text-black pl-4 font-bold">
            Start searching to see specific employee details here
          </h1>
        </div>
        <div className="flex flex-row items-center gap-3 flex-wrap">
          <h1 className="text-gray-600 pt-2 pl-4"> Employee Type: </h1>
          <h1 className="ml-4">
            <Select
              id="employeeType"
              name="employeeType"
              value={employeeType}
              onChange={handleChange}
              style={{
                borderColor: "gray",
                marginTop: "8px",
                width: "300px",
                marginLeft: "14px",
                borderRadius: "22px",
                height: "40px",
              }}
            >
              <MenuItem value="currentEmployee">Current Employee</MenuItem>
              {/* <MenuItem value="resignedEmployee">Resigned Employee</MenuItem> */}
            </Select>
          </h1>
          <button
            className={`${
              selectedEmployee?.id
                ? "bg-blue-500 text-white cursor-pointer"
                : "bg-gray-300 text-black"
            }   font-medium p-2 rounded-md ml-4 transition-colors duration-300`}
            onClick={() => setSelectedEmployee("")}
          >
            View All Employee Leaves
          </button>
          {!selectedEmployee?.id && (
            <>
              <button
                onClick={() => handleExport("all")}
                className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 text-sm rounded"
              >
                <FaFileExcel size={14} />
                Export All Employees to Excel
              </button>

              <button
                onClick={() => handleDownload("all")}
                className="flex items-center gap-2 bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 text-sm rounded"
              >
                <FaFilePdf size={14} />
                Download All Employees PDF
              </button>
            </>
          )}
        </div>

        <h1 className="text-gray-600 pt-2 pl-4">Employee List</h1>
        {employeesIsSuccess && (
          <Select
            id="employeeList"
            name="employeeList"
            value={selectedEmployee ? selectedEmployee.employeeId : "Select Employee"}
            onChange={handleChangeEmployee}
            className="my-2"
            MenuProps={{
              sx: {
                "& .MuiList-root": {
                  maxHeight: 300,
                },
                "& .MuiInputBase-root": {
                  height: 50,
                },
              },
            }}
            style={{
              borderColor: "gray",
              marginTop: "8px",
              width: "300px",
              marginLeft: "14px",
              borderRadius: "22px",
              height: "40px",
            }}
          >
            {employeeData
              .filter((item) => item.employeeId !== getToken("Id"))
              .map((employee) => (
                <MenuItem key={employee.employeeId} value={employee.employeeId}>
                  {employee?.name}
                </MenuItem>
              ))}
          </Select>
        )}
      </div>
      {selectedEmployee?.employeeId ? (
        <>
          <div className="flex items-center gap-3 mb-4 ml-4">
            <h1 className="text-xl font-bold">Overview:</h1>

            <button
              onClick={() => handleExport("single")}
              className="flex items-center gap-2 bg-blue-500 text-white px-3 py-1 text-sm rounded"
            >
              <FaFileExcel size={14} />
              Export Selected Employee Excel
            </button>

            <button
              onClick={() => handleDownload("single")}
              className="flex items-center gap-2 bg-blue-500 text-white px-3 py-1 text-sm rounded"
            >
              <FaFilePdf size={14} />
              Download Selected Employee PDF
            </button>
          </div>
          <div className="mt-4">
            {leavesIsSuccess && (
              <div style={{ minheight: 400, width: "85%", marginLeft: "20px" }}>
                <table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    borderRadius: "10px",
                  }}
                >
                  <thead>
                    <tr>
                      {columns.map((column) => (
                        <th
                          key={column.field}
                          style={{
                            borderBottom: "2px solid lightgray",
                            padding: "8px",
                            backgroundColor: "lightblue", // Light blue background color for headers
                          }}
                        >
                          {column.headerName}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {rows.map((row, rowIndex) => (
                      <tr key={rowIndex}>
                        {columns.map((column) => (
                          <td
                            key={column.field}
                            style={{
                              borderBottom: "2px solid lightgray",
                              borderRight: "none",
                              padding: "8px",
                              backgroundColor:
                                isEditing &&
                                editedRowId === rowIndex &&
                                column.field === "currentAvailableLeaves"
                                  ? "lightyellow"
                                  : "white",
                            }}
                          >
                            {isEditing &&
                            editedRowId === rowIndex &&
                            column.field === "currentAvailableLeaves" ? (
                              <input
                                type="text"
                                value={editedValue}
                                onChange={(e) => setLeavesEditedValue(e)}
                                className="w-full p-2 border rounded focus:outline-none focus:ring focus:ring-blue-400"
                              />
                            ) : column.field === "leaveType" ? (
                              (leaveTypeData.find(
                                (item) => item._id === row[column.field],
                              )?.leaveCategory ?? "")
                            ) : (
                              row[column.field]
                            )}
                          </td>
                        ))}
                        <td>
                          {isEditing && editedRowId === rowIndex ? (
                            <button
                              className="ml-4 px-4 py-2 bg-green-500 text-white rounded hover:bg-green-600 focus:outline-none focus:ring focus:ring-green-400"
                              onClick={() => handleSaveEdit(rowIndex)}
                            >
                              Save
                            </button>
                          ) : (
                            <button
                              className="ml-4 px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600 focus:outline-none focus:ring focus:ring-blue-400"
                              onClick={() => handleEditClick(rowIndex, row)}
                            >
                              Edit
                            </button>
                          )}
                          <Dialog
                            open={openDialog === rowIndex}
                            onClose={handleCloseDialog}
                          >
                            <DialogTitle>Confirm Save</DialogTitle>
                            <DialogContent>
                              <DialogContentText>
                                Are you sure you want to save this change?
                                <p className="text-[#FF9800]">
                                  Make sure you follow the company's leave
                                  policy.
                                </p>
                              </DialogContentText>
                            </DialogContent>
                            <DialogActions>
                              <Button
                                onClick={handleCloseDialog}
                                color="primary"
                              >
                                Cancel
                              </Button>
                              <Button
                                onClick={handleConfirmSave}
                                color="primary"
                              >
                                Yes
                              </Button>
                            </DialogActions>
                          </Dialog>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {isEditing && leavesError && (
                  <p className="text-[#FF9800] font-medium">
                    Please Contact your managment to add more than 30 leaves.
                  </p>
                )}
              </div>
            )}
          </div>
          <h1 className="mt-12 text-xl font-bold ml-4">Leave Transcations:</h1>
          <div className="mt-4">
            {leavesIsSuccess && (
              <div style={{ minheight: 400, width: "85%", marginLeft: "20px" }}>
                <table
                  style={{
                    borderCollapse: "collapse",
                    width: "100%",
                    borderRadius: "10px",
                    tableLayout: "fixed",
                  }}
                >
                  <thead>
                    <tr>
                      {transactionColumns.map((column) => (
                        <th
                          key={column.field}
                          style={{
                            borderBottom: "2px solid lightgray",
                            padding: "8px",
                            textAlign: "center",
                            backgroundColor: "lightblue", // Light blue background color for headers
                          }}
                        >
                          {column.headerName}
                        </th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {leaveTranscations?.map((item) => (
                      <tr key={item?.timeStamp} className="text-center my-2">
                        <td>{item?.eventActor || "-"}</td>
                        <td>{item?.leaveType || "-"}</td>
                        <td>
                          {dayjs(item?.timeStamp).format("DD MMM YYYY") || "-"}
                        </td>
                        <td>{item?.previousLeaves ?? "-"}</td>
                        <td>{item?.updatedleaves ?? "-"}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            )}
          </div>
        </>
      ) : (
        <div className="m-5 relative flex flex-col w-[90%] h-full overflow-scroll bg-white shadow-md rounded-xl bg-clip-border">
          <ViewAllEmployeeLeaves
            data={leavesData}
            leaveIds={leaveTypeData}
            onClickFunction={change}
          />
        </div>
      )}
    </>
  );
}
